import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const CaretLeftIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="m15.75 18-7.5-6 7.5-6v12Z"/>
        </svg>
    </IconWrapper>
));
